import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary-600">
            <i className="ri-question-answer-line text-sm"></i>
            Community
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-2">
            Domande &amp; Esperienze
          </h2>
          <p className="text-foreground-600 text-sm mt-3 max-w-lg mx-auto">
            Le risposte alle domande più frequenti sul mondo Itaobuy Spreadsheet
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="border-b border-background-200 last:border-b-0"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between py-5 text-left cursor-pointer group"
              >
                <h3 className="text-base font-medium text-foreground-900 pr-4 group-hover:text-primary-600 transition-colors">
                  {faq.question}
                </h3>
                <span className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${
                  openId === faq.id
                    ? 'bg-primary-100 text-primary-600 rotate-45'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-[500px] pb-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}